import mainCaller from './mainCaller';

export const getProgramCategory = async token => {
  return await mainCaller(`admin/api/v1/programs/categories`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createProgramCategory = async (data, token) => {
  return await mainCaller(`admin/api/v1/programs/categories`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const deleteProgramCategory = async (id, token) => {
  return await mainCaller(`admin/api/v1/programs/categories/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const updateProgramCategory = async (data, token, id) => {
  return await mainCaller(`admin/api/v1/programs/categories/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const getPrograms = async (query, token) => {
  return await mainCaller(`admin/api/v1/programs?${query}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createPrograms = async (data, token) => {
  return await mainCaller(`admin/api/v1/programs`, 'POST', data, {
    Authorization: `Bearer ${token}`,
  });
};

export const deletePrograms = async (id, token) => {
  return await mainCaller(`admin/api/v1/programs/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const updatePrograms = async (data, token, id) => {
  return await mainCaller(`admin/api/v1/programs/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
  });
};
export const getProgramSession = async (id, token) => {
  return await mainCaller(`admin/api/v1/programs/sessions?programId=${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};
export const getProgramSessionId = async (id, token) => {
  return await mainCaller(`admin/api/v1/programs/sessions/${id}`, 'GET', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const createProgramSession = async (data, token) => {
  return await mainCaller(`admin/api/v1/programs/sessions`, 'POST', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};

export const deleteProgramSession = async (id, token) => {
  return await mainCaller(`admin/api/v1/programs/sessions/${id}`, 'DELETE', null, {
    Authorization: `Bearer ${token}`,
  });
};

export const updateProgramSession = async (data, token, id) => {
  return await mainCaller(`admin/api/v1/programs/sessions/${id}`, 'PUT', data, {
    Authorization: `Bearer ${token}`,
    'Content-type': 'multipart/form-data',
  });
};
